// src/Api/useUncategorizedGroupedApi.js
import { useState } from "react";
import { post } from "./api";

const useUncategorizedGroupedApi = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUncategorizedGrouped = async (payload) => {
    try {
      setLoading(true);

      const response = await post("uncategorized/grouped", payload);

      console.log("Grouped response ====", response);

      // API returns:
      // { data: [ { domain, count, entries: [...] } ] }

      const dataArray = response?.data || [];

      const normalized = dataArray.map((item) => ({
        domain: item.domain,
        count: item.count,
        entries: item.entries || [], // <-- KEEP ENTRIES
      }));

      setGroups(normalized);
    } catch (error) {
      console.error("Error fetching grouped data:", error);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  };

  return { getUncategorizedGrouped, groups, loading };
};

export default useUncategorizedGroupedApi;
